import React, { Component } from "react";
import * as R from "ramda";
import { connect } from "react-redux";

import { Link } from "react-router";

import { eventDetails } from "redux/modules/event/selectors";
import { getValue } from "../../utils";

const decorate = connect(state => ({
  eventDetails: eventDetails(state)
}));

class AssignedPortal extends Component {
  render() {
    const portalId = getValue(this.props, "portal_id");
    const portalName = getValue(this.props, "portal_name");
    const dashboardId = R.pathOr("", ["data", "type", "id"], this.props);
    const returnTo =
      getValue(this.props, "returnTo") || `viaDashboard=${dashboardId}`;
    const path = `/event-light/${
      this.props.eventDetails.id
    }/portals/config-sets/${portalId}/customize?${returnTo ? returnTo : ""}`;

    if (!portalId) {
      return (
        <div
          style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {portalName}
        </div>
      );
    }

    return (
      <Link
        to={path}
        className="underline-on-hover"
        style={{
          cursor: "pointer",
          width: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
      >
        {portalName}
      </Link>
    );
  }
}

export default decorate(AssignedPortal);
